import CopyPasteProvider from './CopyPasteProvider';

export default {
	__init__: ['copyPasteProvider'],
	copyPasteProvider: ['type', CopyPasteProvider],
};

